import { Link } from 'react-router-dom';
import { getCategoryName } from '@/components/base/Breadcrumb';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  imageUrl: string;
  tags: string[];
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  category,
  date,
  readTime,
  imageUrl,
}: ArticleCardProps) {
  return (
    <article className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden group hover:border-primary-200/60 transition-all duration-300">
      <Link to={`/article/${slug}`} className="block">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
          <div className="absolute top-3 left-3">
            <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-background-50/90 text-foreground-700 backdrop-blur-sm whitespace-nowrap">
              {getCategoryName(category)}
            </span>
          </div>
        </div>
        <div className="p-5">
          <h3 className="font-heading font-semibold text-base text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {title}
          </h3>
          <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2">
            {excerpt}
          </p>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3 text-xs text-foreground-500">
              <span className="flex items-center gap-1">
                <i className="ri-time-line" />
                {readTime}
              </span>
              <span>{date}</span>
            </div>
            <span className="flex items-center gap-1 text-xs text-primary-600 font-medium whitespace-nowrap">
              阅读更多
              <i className="ri-arrow-right-line" />
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}